<template>
  <div class="signinCode" :style="{ marginTop: '16px' }">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginFormRules"
      auto-complete="on"
      label-position="left"
    >
      <el-form-item prop="account_id" v-if="loginTab == '1'">
        <div class="phone_box">
          <el-input
            ref="account_id"
            v-model.trim="loginForm.account_id"
            placeholder="请输入账号"
            name="account_id"
            maxlength="11"
            tabindex="1"
            auto-complete="on"
            clearable
            @blur="loginForm.account_id = $event.target.value"
          >
            <!-- <i slot="prefix" class="left_phone">
              <span>+86</span>
              <span class="el-icon-arrow-down" />
              <span class="line" />
            </i> -->
          </el-input>
        </div>
      </el-form-item>
      <el-form-item prop="phone" v-else>
        <div class="phone_box">
          <el-input
            ref="phone"
            v-model.trim="loginForm.phone"
            placeholder="请输入登录韵镖侠的手机号"
            name="phone"
            tabindex="1"
            auto-complete="on"
            clearable
            @blur="loginForm.phone = $event.target.value"
          >
            <!-- <i slot="prefix" class="left_phone">
              <span>+86</span>
              <span class="el-icon-arrow-down" />
              <span class="line" />
            </i> -->
          </el-input>
        </div>
      </el-form-item>

      <!-- oninput="value=value.replace(/[^\d.]/g,'')"  maxlength="11"  maxlength="6"-->
      <el-form-item prop="password" v-if="loginTab == '1'">
        <div class="code_input">
          <el-input
            v-model.trim="loginForm.password"
            placeholder="请输入密码"
            :type="passwordType"
            name="password"
            @blur="loginForm.password = $event.target.value"
            @keyup.enter.native="
              loginForm.password = $event.target.value;
              login();
            "
            show-password
          >
          </el-input>
        </div>
      </el-form-item>
      <el-form-item prop="passwordTwo" v-else>
        <div class="code_input">
          <el-input
            v-model.trim="loginForm.passwordTwo"
            placeholder="请输入密码"
            :type="passwordType"
            name="passwordTwo"
            @blur="loginForm.passwordTwo = $event.target.value"
            @keyup.enter.native="
              loginForm.passwordTwo = $event.target.value;
              login();
            "
            show-password
          >
          </el-input>
        </div>
      </el-form-item>
      <!-- <div class="tips" v-html="tips"></div> -->
      <div class="rember_box">
        <div v-if="loginTab == '1'">
          <el-checkbox-group v-model="checkeds">
            <el-checkbox>
              <span class="login_text">记住密码</span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-else>
          <el-checkbox-group v-model="checkedsTwo">
            <el-checkbox>
              <span class="login_text">记住密码</span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="forget_box">
          <!-- <div class="question_box">
            <svg-icon icon-class="circle-question" class-name="question_text" />
          </div> -->
          <div class="forget_text" v-if="loginTab == '1'">
            <span
              @click="
                $message({
                  message: '请打开韵商宝小程序查看-我的-账号',
                  type: 'warning',
                })
              "
              >获取账号</span
            >
            |
            <span
              @click="
                $message({
                  message:
                    '请先使用微信扫码登录，可在账号信息页重新设置登录密码',
                  type: 'warning',
                })
              "
              >忘记密码</span
            >
          </div>
          <div class="forget_text" v-else>
            <span
              @click="
                $message({
                  message:
                    '请先使用手机验证码登录，可在账号信息页重新设置登录密码',
                  type: 'warning',
                })
              "
              >忘记密码</span
            >
          </div>
        </div>
      </div>
      <el-button size="mini" @click="login">登录</el-button>
    </el-form>
    <div class="login-alert" v-if="loginTab == '1'">未注册用户，请使用手机验证码登录注册，忘记密码登录后，可以修改新密码</div>
  </div>
</template>

<script>
import home from "@/api/home";
import util from "@/util/util";
import CryptoJS from "crypto-js";
const key = CryptoJS.enc.Utf8.parse("1234123412ABCDEF"); //十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse("ABCDEF1234123412"); //十六位十六进制数作为密钥偏移量
const isPhoneNumber = new RegExp(/^[1]([3-9])[0-9]{9}$/);
const isAccountId = new RegExp(/^\d{8,9}$/)
// /^1(?:(?:3[\d])|(?:4[5-7|9])|(?:5[0-3|5-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1|8|9]))\d{8}$/g;
export default {
  name: "LoginAccount",
  props: {
    loginTab: {
      required: true,
      type: String,
    },
  },
  data() {
    const validateAccount = (rule, value, callback) => {
      if (!value) {
         callback(new Error("请填写账号"));
      } else {
        if(!isAccountId.test(value)){
          callback(new Error("请填写正确的账号"));
        }else{
          callback();
        } 
      }
    };
    const validateusername = (rule, value, callback) => {
      if (!value) {
         callback(new Error("请填写账号"));
      } else {
        if(!isPhoneNumber.test(value)){
          callback(new Error("请填写正确的账号"));
        }else{
          callback();
        } 
      }
      // if (!isPhoneNumber.test(value)) {
      //   callback(new Error("请填写正确的手机号"));
      //   return;
      // } else {
      //   callback();
      // }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码！"));
      } else {
        if (value.length >= 6 && value.length <= 20) {
          callback();
        } else {
          callback(new Error("密码不符合6-20个字符规范，请重新输入！"));
        }
      }
    };
    return {
      loginForm: {
        // username: "",
        account_id: "",
        password: "",
        phone: "",
        passwordTwo: "",
      },
      loginFormRules: {
        account_id: [
          { required: true, trigger: ["blur", "change"], validator: validateAccount},
        ],
        phone: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validateusername,
          },
        ],
        password: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validatePass,
          },
        ],
        passwordTwo: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator: validatePass,
          },
        ],
      },
      checkeds: false,
      checkedsTwo: false,
      passwordType: "password",
      countInterval: null,
      throttleFlag: true,
      // tips: "", //
    };
  },
  // computed: {
  //   getSendBtnText() {
  //     if (this.countNum > 0 && this.loginForm.username.length > 0) {
  //       return this.countNum + "秒后重新获取";
  //     } else {
  //       return "获取验证码";
  //     }
  //   },
  // },
  beforeDestroy() {
    if (this.countInterval) {
      clearInterval(this.countInterval);
    }
  },
  created() {
    this.getCookie();
  },
  methods: {
    setCookie(c_name, c_pwd, exdays, keyString) {
      var exdate = new Date(); // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); // 保存的天数
      if (keyString == "checkeds") {
        // 字符串拼接cookie
        window.document.cookie =
          "username" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie =
          "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      } else {
        window.document.cookie =
          "userphone" +
          "=" +
          c_name +
          ";path=/;expires=" +
          exdate.toGMTString();
        window.document.cookie =
          "password_phone" +
          "=" +
          c_pwd +
          ";path=/;expires=" +
          exdate.toGMTString();
      }
      // window.document.cookie =
      //   "recordPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    clearCookie: function (keyString) {
      this.setCookie("", "", -1, keyString); // 修改2值都为空，天数为负1天就好了
    },
    checkedPwd(username, pwd, keyString) {
      // 记住密码进行cookie存储和密码加密
      if (this[keyString]) {
        // Encrypt 加密
        let cont = CryptoJS.enc.Utf8.parse(pwd);
        let cryptoJsPwd = CryptoJS.AES.encrypt(cont, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }).toString();
        // 账号密码保存天数
        this.setCookie(username, cryptoJsPwd, 7, keyString);
      } else {
        // 清空
        this.clearCookie(keyString);
      }
    },
    getCookie: function () {
      let a = util.getCookie("password_phone");
      let b = util.getCookie("password");
      // this.checkeds = Boolean(util.getCookie("recordPwd"));
      this.loginForm.account_id = util.getCookie("username");
      this.loginForm.phone = util.getCookie("userphone");
      if (this.loginForm.account_id) {
        // 密码解密
        let password = CryptoJS.AES.decrypt(util.getCookie("password"), key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }).toString(CryptoJS.enc.Utf8);
        this.loginForm.password = password;
        this.checkeds = true;
      }
      if (this.loginForm.phone) {
        // 密码解密
        let password2 = CryptoJS.AES.decrypt(
          util.getCookie("password_phone"),
          key,
          {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        ).toString(CryptoJS.enc.Utf8);
        this.loginForm.passwordTwo = password2;
        this.checkedsTwo = true;
      }
    },

    // startTimer(param) {
    //   let _this = this;
    //   _this.countInterval = setInterval(() => {
    //     _this.countNum--;
    //     if (_this.countNum > 0) {
    //       _this.getSendBtnText =
    //         _this.countNum + (param > 1000 ? "分钟" : "秒") + "后重新获取";
    //     } else if (_this.countNum <= 0) {
    //       _this.getSendBtnText = "获取验证码";

    //       clearInterval(_this.countInterval);
    //     }
    //   }, param);
    // },
    jgenv() {
      let redirect_uri = "";
      if (util.jgEnv() == 'pro') {
        // 生产环境
        redirect_uri = "https://ysbywy.yundasys.com";
      } else {
        // // 开发环境
        redirect_uri = "http://10.172.17.136:10086";
        // redirect_uri = "http://10.20.133.192:9527";
      }
      return redirect_uri;
    },
    login() {
      if (this.loginTab == "1") {
        let username = this.loginForm.account_id;
        let pwd = this.loginForm.password;
        this.checkedPwd(username, pwd, "checkeds");
      } else {
        let username2 = this.loginForm.phone;
        let pwd2 = this.loginForm.passwordTwo;
        this.checkedPwd(username2, pwd2, "checkedsTwo");
      }
      //调用check选中方法
      // return;
      let _this = this;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          home.accountLogin(this, true).then((res) => {
            if (res.data.code == 200 && res.success) {
              if (_this.loginTab == "1") {
                util.setCookie("account_id", res.data.data.account_id);
                util.setCookie("token", res.data.token);
                util.setCookie(
                  "websocket_token",
                  res.data.data.websocket_token
                );
                util.setCookie("app_key", res.data.data.app_key);
                util.setCookie("nickname", res.data.data.nickname);
                util.setCookie("headimgurl", res.data.data.headimgurl);
                // debugger;
                _this.$router.push("/loading");
              }
              _this.loginTab == "2" &&
                (window.location.href =
                  _this.jgenv() +
                  "?token=" +
                  res.data.token +
                  "&websocket_token=" +
                  res.data.data.websocket_token +
                  "&appKey=" +
                  res.data.data.app_key +
                  "&account_id=" +
                  res.data.data.account_id);
            }else if(res.data.code == 8018){     
              this.$message({
                message:
                  "该账号已锁定，请先使用微信扫码登录，或于一小时后重新尝试",
                type: "warning",
              });              
            }else{
              this.$message.error('登录失败')
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.signinCode {
  margin: 50px auto 15px;
  width: 360px;
  // width: 299px;
  .phone_box {
    ::v-deep .el-input--prefix .el-input__inner {
      padding-left: 55px;
    }
  }
  // .code_input {
  //   ::v-deep .el-input--suffix .el-input__inner {
  //     padding-right: 85px;
  //   }
  //   .svg-icon {
  //     fill: #c0c4cc;
  //     width: 24px;
  //     height: 24px;
  //     vertical-align: -8px;
  //   }
  // }
.tips{
  font-size:12px;
  margin-top: -11px
  ::v-deep i{
    color: #F56C6C;
    font-style:normal
  }
}
.rember_box{
  display: flex;
  justify-content: space-between;
  >div:first-child{
      /deep/.login_text{
        color: #999999a8;
      }
  }
  .forget_box{
    color: #2ea2fc;
    font-size: 13px;
    span{
      cursor: pointer;
    }
  }
}
  .line {
    height: 20px;
    border: 1px solid #dcdfe6;
    margin: 0 5px;
  }
  .code_line {
    width: 0px;
    height: 20px;
    border: 1px solid #dcdfe6;
    margin: 0 10px;
  }
  .code {
    cursor: pointer;
    // background: #1b72e9;
    background: #409EF2;
    color: #fff;
    padding: 0 10px;
  }
  /deep/.el-input__suffix{
    right: 0
  }
  .codeTxt{
    display: flex;
    align-items: center;
    border-radius:0 4px 4px 0;
    overflow: hidden;
  }
  /deep/.el-form-item {
    // margin-bottom: 33px;
    margin-bottom: 20px;
  }
  /deep/button{
    width 100%;
    // background: #1b72e9;
    background: #409EF2;
    color: #fff;
    // height: 40px;
    height: 48px;
    // margin-top: 20px;
    margin-top: 30px;
    font-size: 16px;
    font-weight: 500;
    font-family: "PingFang SC";
  }

  .login-alert {
    margin-top: 10px;
    color: #888888;
    font-size: 12px;
    font-weight: 400;
    height: 36px;
  }
}
</style>
